import { TIKTOK_TRACKER_NAME } from '../../constants';
import { framework, rules } from '@buzzfeed/consent';

export class TiktokTracker {
  constructor({ trackingId, cluster }) {
    this.trackingId = trackingId;
    this.cluster = cluster;
    this.loaded = false;

    if (typeof window === 'undefined') {
      return {
        trackEvent: () => {},
        _loadTiktokScript: () => {},
        _getTiktokTracker: () => {},
      };
    }
  }

  _loadTiktokScript() {
    // if we are not in prod, don't actually call the script - load as a mock logger instead
    if (this.cluster !== 'prod') {
      this.loaded = true;
      return true;
    }

    try {
      /* eslint-disable */

      !(function (w, d, t) {
        w.TiktokAnalyticsObject = t
        var ttq = (w[t] = w[t] || [])
        ttq.methods = [
          'page',
          'track',
          'identify',
          'instances',
          'debug',
          'on',
          'off',
          'once',
          'ready',
          'alias',
          'group',
          'enableCookie',
          'disableCookie',
        ]

        ttq.setAndDefer = function (t, e) {
          t[e] = function () {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
          }
        }

        for (var i = 0; i < ttq.methods.length; i++) {
          ttq.setAndDefer(ttq, ttq.methods[i])
        }

        ttq.instance = function (t) {
          for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) {
            ttq.setAndDefer(e, ttq.methods[n])
          }
          return e
        }

        ttq.load = function (e, n) {
          var i = 'https://analytics.tiktok.com/i18n/pixel/events.js'
          ttq._i = ttq._i || {}
          ttq._i[e] = []
          ttq._i[e]._u = i
          ttq._t = ttq._t || {}
          ttq._t[e] = +new Date()
          ttq._o = ttq._o || {}
          ttq._o[e] = n || {}
          var o = document.createElement('script')
          o.type = 'text/javascript'
          o.async = !0
          o.src = i + '?sdkid=' + e + '&lib=' + t
          var a = document.getElementsByTagName('script')[0]
          a.parentNode.insertBefore(o, a)
        }

        ttq.load('CBGPMSJC77U9N02IOQ30')
      })(window, document, TIKTOK_TRACKER_NAME)
      /* eslint-enable */

      return true;
    } catch {
      return false;
    }
  }

  async _getTiktokTracker() {
    if (window[TIKTOK_TRACKER_NAME] && this.loaded) {
      return window[TIKTOK_TRACKER_NAME];
    }

    // check to see if we have consent before we load anything
    const needsConsent = framework.needsConsent();
    let hasTrackingConsent;

    if (!needsConsent) {
      this._loadTiktokScript();
    } else {
      try {
        hasTrackingConsent = await rules.hasConsented('tracking');
        if (hasTrackingConsent) {
          this._loadTiktokScript();
        }
      } catch {
        // @todo - logging for load fail
      }
    }

    // if we've made it this far, we don't have consent or couldn't load the script
    // load mock fns to prevent app error, but don't log anything out
    if (!window[TIKTOK_TRACKER_NAME]) {
      window[TIKTOK_TRACKER_NAME] = {
        page: () => {},
        track: () => {},
      };

      // if we explicitly do not have consent, mock config so we don't try to load again for this page
      // otherwise, we will retry load the next time this function is called
      if (typeof hasTrackingConsent !== 'undefined' && !hasTrackingConsent) {
        this.loaded = true;
      }
    }

    return window[TIKTOK_TRACKER_NAME];
  }

  async trackEvent({ eventType, data }) {
    const tracker = await this._getTiktokTracker();
    tracker.track(eventType, data || {});
  }

  async trackPageview() {
    const tracker = await this._getTiktokTracker();
    tracker.page();
  }
}
